import { api } from 'api';
import CheckboxIcon from 'assets/icons/checkbox-icon.svg';
import CheckedIcon from 'assets/icons/checked-icon.svg';
import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import { TRANSACTION_PAYLOAD_INIT } from 'components/FormAddTransaction/func';
import ButtonCommon from 'components/common/ButtonCommon';
import {
  ADD_TRANSACTION_MESSAGE_NAME,
  ADD_TRANSACTION_METHOD_BANK_NAME,
  ADD_TRANSACTION_METHOD_EWALLET_NAME,
  ADD_TRANSACTION_METHOD_PICKUP_NAME,
  ADD_TRANSACTION_OCCUPATION_NAME,
  ADD_TRANSACTION_PAYMENT_METHOD_NAME,
  ADD_TRANSACTION_PAYOUT_METHOD_NAME,
  ADD_TRANSACTION_PREVIOUS_EMPLOYED_NAME,
  ADD_TRANSACTION_PURPOSE_NAME,
  ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME,
  ADD_TRANSACTION_RECEIVER_GET_NAME,
  ADD_TRANSACTION_RELATIONSHIP_NAME,
  ADD_TRANSACTION_SOURCE_NAME,
  ADD_TRANSACTION_TICK_CHECKBOX_FIELD,
  ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME,
  ADD_TRANSACTION_YOU_SEND_NAME,
  METHOD_DEPOSIT,
  METHOD_EPAYMENT,
  METHOD_PAYID,
  PAYMENT_CREADIT_CARD_NO,
  PAYMENT_CREADIT_CARD_TYPE,
  RESET_ADD_TRANSACTION_INFORMATION_STORE,
  RESET_PAYMENT_BY_DEPOSIT_STORE,
  STATUS_FAIL,
  STATUS_SUBMITTED,
  STATUS_SUCCESS,
} from 'constants';
import useAuth from 'hooks/useAuth';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useQuery from 'hooks/useQuery';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import { useEffect, useRef, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { stateStore } from 'store';
import {
  SET_ADD_TRANSACTION_CURRENT_STEP,
  SET_ADD_TRANSACTION_INFORMATION,
  SET_CURRENT_RECEIVER,
  SET_SHOW_LOADING,
  SET_SHOW_PENDING,
} from 'store/action';
import styled from 'styled-components';
import { numberUtils, stringUtils } from 'utils/func';

import withLoadEvent, { MOBILE_VIEW_MODAL } from 'HOCs/withLoadEvent';
import {
  findDiscountDetails,
  handleRemoveDiscountApplied,
  getReviewPayDiscountRecoveryAction,
  handleReviewPayDiscountRecoveryClose,
  handleReviewPayDiscountRecoveryViewOtherOffers,
  isDiscountErrorCode,
} from 'components/Discount/func';
import InformPopup from 'components/common/InformPopup';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { IS_PAYTO_CONFIG_DISABLE } from 'config';
import {
  ADD_TRANSACTION_PAYMENT_METHOD_ITEM_NAME,
  ADD_TRANSACTION_STEP_REFERENCE,
  ADD_TRANSACTION_TICK_CHECKBOX,
  DESKTOP_MIN_WIDTH,
  FUNC_DEFAULT,
  HOME_URL,
  METHOD_PAYTO,
  OBJECT_DEFAULT,
  SCREEN_ID_REMITTANCE_STEP_4,
  SCREEN_ID_REMITTANCE_SUCCESS,
  SENDER_ID,
  THROTTLE_SUBMIT_SEC,
  TRANSACTION_ADD_PREFIX,
} from 'constants';
import {
  buildInvalidatedQuoteAuthorityResponse,
  getCurrentQuoteAuthority,
  getIsQuoteAuthorityUsable,
} from 'features/calculatorRounding/func/quoteLifecycle';
import useCalculatorRoundingStore from 'features/calculatorRounding/hooks/useCalculatorRoundingStore';
import withAddPaytoAccountsAgreement from 'features/to/HOCs/payment/withAddPaytoAccountsAgreement';
import withLoadPaytoAccountsAgreementInitial from 'features/to/HOCs/payment/withLoadPaytoAccountsAgreementInitial';
import withPayByPayto from 'features/to/HOCs/payment/withPayByPayto';
import withPaymentMethodAutoSelect from 'features/to/HOCs/payment/withPaymentMethodAutoSelect';
import withPaytoErrorCodeModal from 'features/to/HOCs/payment/withPaytoErrorCodeModal';
import PaytoAccountsAgreement from 'features/to/components/payment/payto/PaytoAccountsAgreement';
import usePayment from 'features/to/hooks/payment/usePayment';
import usePaytoAPI from 'features/to/hooks/payment/usePaytoAPI';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import { Fade } from 'helpers/animation';
import Cookies from 'helpers/cookies';
import { checkMaintenance, checkSystemError } from 'helpers/maintenance';
import useAddTransaction, {
  MAKE_PAYMENT_KEY,
} from 'hooks/form-add-transaction/useAddTransaction';
import useFormAddTransactionStore from 'hooks/form-add-transaction/useFormAddTransactionStore';
import useCheckServiceAlerts from 'hooks/service-alerts/useCheckServiceAlerts';
import useServiceAlertsConfig from 'hooks/service-alerts/useServiceAlertsConfig';
import useServiceAlertsStore from 'hooks/service-alerts/useServiceAlertsStore';
import useServiceAlertsUtil from 'hooks/service-alerts/useServiceAlertsUtil';
import useAutoShowEventModal from 'hooks/useAutoShowEventModal';
import useCountryConfigUtils from 'hooks/useCountryConfigUtils';
import usePortalModal from 'hooks/usePortalModal';
import useScrollIntoView from 'hooks/useScrollIntoView';
import useScrollIntoViewDelay from 'hooks/useScrollIntoViewDelay';
import useThrottle from 'hooks/useThrottle';
import useTxnSubmitError from 'hooks/useTxnSubmitError';
import { isArray, isEmpty, isObject } from 'lodash';
import BodySectionHeader from '../../BodySectionHeader';
import CalculatorForm from '../../CalculatorForm/ver2';
import FormPaymentByDeposit from '../../FormPaymentByDeposit';
import FormPaymentByDepositMobile from '../../FormPaymentByDeposit/mobile/ver2';
import FormTransactionDetails from '../../FormTransactionDetails';
import FormTransactionDetailsMobile from '../../FormTransactionDetails/mobile';
import PaymentMethodsGrid from '../../PaymentMethodsGrid/ver2';
import {
  ActionWrapper,
  ButtonCommonWrap,
  NextWrap,
} from '../../Remittance/ver2';
import TransactionSummary from '../../TransactionSummary';

const PaymentMethodsGridExt = withLoadPaytoAccountsAgreementInitial(
  withPaymentMethodAutoSelect(PaymentMethodsGrid),
);
const TransactionSummaryWithEvent = withLoadEvent(TransactionSummary);

const initialFormField = RESET_ADD_TRANSACTION_INFORMATION_STORE.paymentMethod;
const initialFormCard = RESET_PAYMENT_BY_DEPOSIT_STORE;

// DEV-1385: the step that has amount inputs. Step indices are 0-based, and index
// 2 (`additionalInformation`) collects additional information and has NO amount
// field — returning the customer there makes the refusal's recovery invisible,
// because they press Continue once and meet the same refusal. See
// ADD_TRANSACTION_STEP_REFERENCE.
const STEP_INDEX_AMOUNT = 1;

const PaymentMethod = withPayByPayto(
  withAddPaytoAccountsAgreement(
    withPaytoErrorCodeModal(
      ({
        countryConfig,
        handleOnToggleCancelPopup,
        isDisabled,
        onCheckReceiverVerifiedByOTP,
        showPaytoOTPVerificationModal,
        onOpenPaytoErrorCodeModal,
      }) => {
        const { t, locate } = useLang();
        const { state, dispatch } = useStore();
        const {
          addTransactionInformation,
          currentReceiver,
          addTransactionCurrentStep: currentStep,
          currentUser,
          paytoAccountInformation,
          calculatorRoundingResponse,
          transactionDetails,
        } = state;
        const { senderId } = currentUser || {};
        const {
          receiverPayoutMethod,
          remittance,
          additionalInformation,
          paymentMethod: paymentStore,
        } = addTransactionInformation;
        const { token } = useAuth();
        const { theme } = useTheme();
        const query = useQuery();
        const { isMobile, isTablet, isDesktop } = useDetectDevice();
        const navigate = useNavigate();
        const tickRef = useRef(null);
        const { showPortalModalName } = usePortalModal();
        const { throttle, isThrottleLocked, resetThrottle } =
          useThrottle(THROTTLE_SUBMIT_SEC);
        const { showTxnSubmitErrorModal } = useTxnSubmitError();
        const { setCalculatorRoundingResponse } = useCalculatorRoundingStore();

        const { currentRateStore, currentRateAnotherStore } = remittance || {};
        const { quoteToken, fee } = calculatorRoundingResponse || {};

        const [information, setInformation] = useState(initialFormField);
        const [validation, setValidation] = useState(initialFormField);
        const [isTickChecked, setTickChecked] = useState(false);
        const [isShowTransactionDetails, setShowTransactionDetails] =
          useState(false);
        const [isShowFormPaymentByDeposit, setShowFormPaymentByDeposit] =
          useState(false);
        const [transactionInformation, setTransactionInformation] =
          useState(null);
        const [cardInformation, setCardInformation] = useState(initialFormCard);
        const [cardValidation, setCardValidation] = useState(initialFormCard);
        const [isShowDiscountInvalidPopup, setShowDiscountInvalidPopup] =
          useState(false);
        const [errorCode, setErrorCode] = useState('');
        const [failedDiscount, setFailedDiscount] = useState(null);
        const [hasOtherEligibleDiscounts, setHasOtherEligibleDiscounts] =
          useState(false);

        const refNumber =
          transactionInformation?.refNumber || query.get('refNumber');
        const isCreateNewTran = !isDisabled;
        const isUpdateTran = isDisabled;

        const { discountsAvailable, discountApplied, discountDetails } =
          paymentStore || {};
        const { discountAmount, totalAmountAfterDiscount } =
          discountApplied || {};
        const isDiscountApplied = Boolean(discountAmount);
        const { serviceAlertsByPayments: serviceAlertsStore } =
          useServiceAlertsStore();
        const { checkByPaymentMethod } = useCheckServiceAlerts();
        const { checkServiceAlertsOfPaymentMethodItemDisable } =
          checkByPaymentMethod || {};
        const { paymentMethod } = useServiceAlertsConfig();
        const { isPreventNextStep4 } = useServiceAlertsUtil();
        const isNextDisabled = false;

        const { isMakePayment, isPaytoBlocked } = useFormAddTransactionStore();

        const { payLimitConfig, isPaymentMethodDisabled } =
          useAddTransaction(countryConfig);

        const { allowReviewAndPay } = usePayment();
        const { paytoAccountsAgreement, resetPaytoAccountsAgreement } =
          usePaytoStore();
        const { payloadTransformFromPaytoAccountInformation } = usePaytoAPI();

        const { getPaymentOptionsConfig } =
          useCountryConfigUtils(countryConfig);
        const isPayToVisibleConfig =
          getPaymentOptionsConfig()?.['payToVisible'];

        useEffect(() => {
          const newInformation = {
            ...paymentStore,
            [ADD_TRANSACTION_PAYMENT_METHOD_NAME]: isObject(
              paymentStore[ADD_TRANSACTION_PAYMENT_METHOD_NAME],
            )
              ? paymentStore[ADD_TRANSACTION_PAYMENT_METHOD_NAME]?.method
              : paymentStore[ADD_TRANSACTION_PAYMENT_METHOD_NAME],
          };
          setInformation(newInformation);
        }, [paymentStore]);

        useEffect(() => {
          if (refNumber) {
            setTickChecked(true);
          }
        }, [refNumber]);

        const isPaymentSuccessfully = currentStep === 4;

        const countryCode = countryConfig?.countryCode;

        const payoutMethod =
          receiverPayoutMethod[ADD_TRANSACTION_PAYOUT_METHOD_NAME];

        const currencyCode = remittance?.currentCurrencySelected?.currencyCode;
        const isOnlyCurrency = !remittance.isAddAnotherReceivingCurrency;

        const isChangePaymentMethod =
          (paymentStore?.paymentMethodTxn &&
            paymentMethod &&
            paymentStore?.paymentMethodTxn !== paymentMethod) ||
          (isMakePayment && !paymentStore?.paymentMethodTxn && paymentMethod);

        const sendAmount = numberUtils.mathRound(
          remittance[ADD_TRANSACTION_YOU_SEND_NAME] || 0,
        );
        const sendAnotherAmount = numberUtils.mathRound(
          remittance[ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME] || 0,
        );
        const sendTotalAmount = numberUtils.mathRound(
          sendAmount + sendAnotherAmount,
        );

        const receiverAmount = Number(
          remittance[ADD_TRANSACTION_RECEIVER_GET_NAME] || 0,
        );

        const feeAmount = numberUtils.mathRound(
          remittance?.feeAmount?.feeAmount || 0,
        );

        const totalAmount = isDiscountApplied
          ? numberUtils.mathRound(totalAmountAfterDiscount)
          : numberUtils.mathRound(feeAmount + sendTotalAmount);

        const totalPayAmount = totalAmount;

        const validRef0 = useRef(null);
        useScrollIntoView(
          validRef0,
          validation[ADD_TRANSACTION_PAYMENT_METHOD_NAME],
          [validation],
        );

        const validRef1 = useRef(null);
        useScrollIntoViewDelay(validRef1, paymentMethod && validRef1, [
          paymentMethod,
          validRef1,
        ]);

        const [isPreventPaymentMethodAutoSelect] = useState(false);

        const handleOnChangeTickChecked = () => {
          setTickChecked(!isTickChecked);

          if (!isTickChecked) {
            const newValidation = {
              ...validation,
              [ADD_TRANSACTION_TICK_CHECKBOX]: '',
            };
            setValidation(newValidation);
          }
        };

        const handleOnCloseTransactionDetailsPopup = () => {
          setShowTransactionDetails(false);
        };

        const handleOnCloseFormPaymentByDeposit = () => {
          setShowFormPaymentByDeposit(false);

          setCardValidation(initialFormCard);

          Cookies.set(MAKE_PAYMENT_KEY, true);

          dispatch({ type: SET_CURRENT_RECEIVER, payload: null });

          resetThrottle();

          navigate(`${TRANSACTION_ADD_PREFIX}?refNumber=${refNumber}`);
        };

        const handleCloseDiscountInvalidPopup = () => {
          handleReviewPayDiscountRecoveryClose({
            errorCode,
            failedDiscount,
          });
          setShowDiscountInvalidPopup(false);
          setErrorCode('');
          setFailedDiscount(null);
          setHasOtherEligibleDiscounts(false);

          if (isShowTransactionDetails) {
            resetThrottle();
          }
        };
        const handleViewOtherOffers = () => {
          setShowDiscountInvalidPopup(false);
          setErrorCode('');
          setHasOtherEligibleDiscounts(false);

          handleReviewPayDiscountRecoveryViewOtherOffers({
            errorCode,
            failedDiscount,
            callback: () => {
              dispatch({
                type: SET_ADD_TRANSACTION_CURRENT_STEP,
                payload: 1,
              });
            },
          });

          if (isShowTransactionDetails) {
            resetThrottle();
          }
        };
        const handleDiscountValidationFailure = (errorCode) => {
          const recoveryAction = getReviewPayDiscountRecoveryAction({
            errorCode,
            paymentMethod: paymentStore,
            countryCode,
            payoutMethod,
            currencyCode,
            isOnlyCurrency,
            sendAmount: sendTotalAmount,
            receiverAmount,
            feeAmount,
            cityId: currentReceiver?.address?.city?.id,
            selectedPaymentMethod: paymentMethod,
          });

          setFailedDiscount(recoveryAction.failedDiscount);
          setHasOtherEligibleDiscounts(recoveryAction.shouldViewOtherOffers);
          setErrorCode(recoveryAction.errorCode);
          setShowDiscountInvalidPopup(true);
        };

        const handleNextStep = () => {
          let newInformation = { ...information };
          let newValidation = { ...validation };

          if (!remittance?.isAddAnotherReceivingCurrency) {
            delete newInformation['rateAnother'];
            delete newValidation['rateAnother'];
          }

          if (!information[PAYMENT_CREADIT_CARD_NO]) {
            delete newInformation[PAYMENT_CREADIT_CARD_NO];
            delete newValidation[PAYMENT_CREADIT_CARD_NO];
          }

          if (!information[PAYMENT_CREADIT_CARD_TYPE]) {
            delete newInformation[PAYMENT_CREADIT_CARD_TYPE];
            delete newValidation[PAYMENT_CREADIT_CARD_TYPE];
          }

          delete newInformation['discountsAvailable'];
          delete newValidation['discountsAvailable'];

          delete newInformation['discountDetails'];
          delete newValidation['discountDetails'];

          delete newInformation['discountsInactive'];
          delete newValidation['discountsInactive'];

          delete newInformation['discountApplied'];
          delete newValidation['discountApplied'];

          if (isTickChecked) {
            delete newInformation[ADD_TRANSACTION_TICK_CHECKBOX];
            delete newValidation[ADD_TRANSACTION_TICK_CHECKBOX];
          }

          if (paymentMethod === METHOD_PAYTO) {
            delete newValidation[ADD_TRANSACTION_PAYMENT_METHOD_ITEM_NAME];
          }

          if (
            paymentMethod === METHOD_PAYTO &&
            checkPaymentMethodItemDisabled(paymentMethod)
          ) {
            newValidation = {
              ...newValidation,
              [ADD_TRANSACTION_PAYMENT_METHOD_NAME]:
                'form_choose_payment_method_invalid',
            };
            setValidation(newValidation);
            return;
          }

          console.log(
            `⭐ PAYMENT_METHOD 👉 handleNextStep ➡️ newInformation ↩`,
            newInformation,
          );
          console.log(
            `⭐ PAYMENT_METHOD 👉 handleNextStep ➡️ newValidation ↩`,
            newValidation,
          );

          const isAllowSubmit =
            Object.values(newInformation).every((value) => value) &&
            Object.values(newValidation).every((value) => !value) &&
            allowReviewAndPay() &&
            isTickChecked;

          if (isAllowSubmit) {
            if (isPreventNextStep4) return;

            const isPayLimit =
              payLimitConfig &&
              isPaymentMethodDisabled(
                isObject(paymentMethod) ? paymentMethod?.method : paymentMethod,
              );
            if (isPayLimit) {
              newValidation = {
                ...newValidation,
                [ADD_TRANSACTION_PAYMENT_METHOD_NAME]:
                  'form_choose_payment_method_invalid',
              };
              setValidation(newValidation);
              return;
            }

            dispatch({
              type: SET_ADD_TRANSACTION_INFORMATION,
              payload: {
                ...addTransactionInformation,
                [ADD_TRANSACTION_STEP_REFERENCE[currentStep]]: information,
              },
            });

            setShowTransactionDetails(true);
          } else {
            if (!isTickChecked) {
              tickRef.current.scrollIntoView({ behavior: 'smooth' });
              newValidation = {
                ...newValidation,
                [ADD_TRANSACTION_TICK_CHECKBOX]: 'required',
              };
              setValidation(newValidation);
              return;
            }

            if (!paymentMethod) {
              newValidation = {
                ...newValidation,
                [ADD_TRANSACTION_PAYMENT_METHOD_NAME]:
                  'form_choose_payment_method_invalid',
              };
            }

            if (paymentMethod === METHOD_PAYTO) {
              newValidation = {
                ...newValidation,
                [ADD_TRANSACTION_PAYMENT_METHOD_ITEM_NAME]: 'required',
              };
            }

            setValidation(newValidation);
          }
        };

        const handlePayProcess = async (refNumber, data) => {
          dispatch({ type: SET_SHOW_LOADING, payload: true });

          const { paymentMethod } = data || {};

          console.log(`⭐ PaymentMethod 👉 handlePayProcess ➡️ txn ↩`, data);
          setTransactionInformation(data);

          if (paymentMethod === METHOD_EPAYMENT) {
            setShowFormPaymentByDeposit(true);
          }

          if (
            paymentMethod === METHOD_PAYID ||
            paymentMethod === METHOD_DEPOSIT
          ) {
            dispatch({ type: SET_ADD_TRANSACTION_CURRENT_STEP, payload: 4 });

            // DEV-1385-03: promote the completed transaction into the URL so
            // its context can no longer reach createTran. `replace: true`
            // (not window.location.href, unlike the mint precedent): a
            // document navigation here would tear down handlePayProcess's
            // still-running caller (api.getOccupation/saveOccupation/
            // updateRelationship below) and wipe the in-memory store the
            // success screen's totalPayAmount depends on for PayID/Deposit.
            navigate(
              `${TRANSACTION_ADD_PREFIX}?refNumber=${refNumber}&paymentStatus=${STATUS_SUCCESS}`,
              { replace: true },
            );
          }

          if (paymentMethod === METHOD_PAYTO) {
            let { paymentPaytoInstruction } = data || {};
            // paymentPaytoInstruction = {
            //   errorCode: 'PTE_0200',
            //   errorMessage: 'Error',
            // };
            const { errorCode, errorMessage } = paymentPaytoInstruction || {};
            if (errorCode || errorMessage) {
              const errorData = {
                errorCode,
                message: errorMessage,
              };
              const homeUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
              const failPath = `${homeUrl}${TRANSACTION_ADD_PREFIX}?refNumber=${refNumber}`;
              onOpenPaytoErrorCodeModal(
                errorData,
                '',
                '',
                FUNC_DEFAULT,
                '',
                {
                  failPath: failPath,
                },
                payloadTransformFromPaytoAccountInformation(
                  paytoAccountInformation,
                ),
              );
            } else {
              dispatch({ type: SET_ADD_TRANSACTION_CURRENT_STEP, payload: 4 });

              // DEV-1385-03: same promotion as PayID/Deposit above, only on
              // the success branch — the OTP/agreement error branch above
              // must not promote, or the init effect would flip into the
              // success branch and unmount the still-open card/OTP form.
              navigate(
                `${TRANSACTION_ADD_PREFIX}?refNumber=${refNumber}&paymentStatus=${STATUS_SUCCESS}`,
                { replace: true },
              );
            }
          }

          setShowTransactionDetails(false);

          dispatch({ type: SET_SHOW_LOADING, payload: false });
        };

        const getCurrency = (dmList, currencyCode) => {
          return dmList
            ?.find(
              (dm) =>
                dm.code ===
                receiverPayoutMethod[ADD_TRANSACTION_PAYOUT_METHOD_NAME],
            )
            ?.currencies?.find((currency) => currency.code === currencyCode);
        };

        const getRemittance = () => {
          const remittances = [];

          remittances.push({
            id: isDisabled ? remittance?.remittanceId : 0,
            sendAmount: remittance[ADD_TRANSACTION_YOU_SEND_NAME] || 0,
            receiveAmount: remittance[ADD_TRANSACTION_RECEIVER_GET_NAME] || 0,
            currency: getCurrency(
              countryConfig?.dmList,
              remittance.currentCurrencySelected?.currencyCode,
            ),
            rate: currentRateStore,
          });

          if (remittance.isAddAnotherReceivingCurrency) {
            remittances.push({
              id: isDisabled ? remittance?.remittanceAnotherId : 0,
              sendAmount:
                remittance[ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME] || 0,
              receiveAmount:
                remittance[ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME] || 0,
              currency: getCurrency(
                countryConfig?.dmList,
                remittance.currentCurrencySelectedAnother?.currencyCode,
              ),
              rate: currentRateAnotherStore,
            });
          }

          return remittances;
        };

        const getPayout = () => {
          const payout = {
            dmCode: receiverPayoutMethod[ADD_TRANSACTION_PAYOUT_METHOD_NAME],
          };

          if (isUpdateTran) {
            if (receiverPayoutMethod[ADD_TRANSACTION_METHOD_PICKUP_NAME])
              return {
                ...payout,
                pickupOffice:
                  receiverPayoutMethod[ADD_TRANSACTION_METHOD_PICKUP_NAME],
              };

            if (receiverPayoutMethod[ADD_TRANSACTION_METHOD_BANK_NAME])
              return {
                ...payout,
                bank: receiverPayoutMethod[ADD_TRANSACTION_METHOD_BANK_NAME],
              };

            if (receiverPayoutMethod[ADD_TRANSACTION_METHOD_EWALLET_NAME])
              return {
                ...payout,
                ewallet:
                  receiverPayoutMethod[ADD_TRANSACTION_METHOD_EWALLET_NAME],
              };
          }

          if (isCreateNewTran) {
            if (receiverPayoutMethod[ADD_TRANSACTION_METHOD_PICKUP_NAME])
              return {
                ...receiverPayoutMethod[ADD_TRANSACTION_METHOD_PICKUP_NAME],
                ...payout,
              };

            if (receiverPayoutMethod[ADD_TRANSACTION_METHOD_BANK_NAME])
              return {
                ...receiverPayoutMethod[ADD_TRANSACTION_METHOD_BANK_NAME],
                ...payout,
              };

            if (receiverPayoutMethod[ADD_TRANSACTION_METHOD_EWALLET_NAME])
              return {
                ...receiverPayoutMethod[ADD_TRANSACTION_METHOD_EWALLET_NAME],
                ...payout,
              };
          }

          return payout;
        };

        const transactionPayload = {
          ...TRANSACTION_PAYLOAD_INIT,
          purpose: additionalInformation[ADD_TRANSACTION_PURPOSE_NAME]?.key,
          source: additionalInformation[ADD_TRANSACTION_SOURCE_NAME]?.key,
          job: additionalInformation[ADD_TRANSACTION_OCCUPATION_NAME]?.key,
          prevJob:
            additionalInformation[ADD_TRANSACTION_PREVIOUS_EMPLOYED_NAME]?.key,
          message: additionalInformation[ADD_TRANSACTION_MESSAGE_NAME],
          subTotal: Number(sendTotalAmount),
          surcharge: 0,
          total: Number(totalAmount),
          totalPay: Number(totalAmount),
          receiverId: currentReceiver?.receiverId,
          payout: getPayout(),
          remittance: getRemittance(),
          fee: fee || remittance.feeAmount,
          paymentMethod,
          relationship:
            additionalInformation[ADD_TRANSACTION_RELATIONSHIP_NAME]?.key,
          discount: isDiscountApplied ? discountApplied : null,
          discountAmount: isDiscountApplied ? discountAmount : 0,
          discountDetails: isDiscountApplied
            ? isUpdateTran
              ? discountDetails
              : findDiscountDetails(discountsAvailable, discountApplied?.code)
            : null,
          quoteToken,
        };

        // DEV-1385: a create that holds no usable quote authority refuses here
        // instead of failing at the backend with a message naming no cause.
        //
        // Recovery is deliberately one edit: the stored amounts are emptied and
        // the customer is returned to the amount step, so re-entering an amount
        // issues a fresh pricing request. Emptying the amounts is load-bearing
        // rather than cosmetic — a mount-time pricing path can otherwise
        // re-price with no customer edit under conditions this work does not
        // control, and empty amounts also falsify the amount step's
        // every-value-truthy gate so Continue is blocked and a real edit is
        // forced.
        //
        // No automatic re-price is attempted: the pricing call does not return
        // the authority, and reading it back in the same update depends on
        // render-commit ordering. The customer's edit is the re-price trigger.
        const refuseCreateWithoutQuoteAuthority = () => {
          dispatch({ type: SET_SHOW_LOADING, payload: false });

          // The PayTo one-time-code path raises a full-screen pending overlay
          // (`features/to/HOCs/payment/withPayByPayto.jsx:33`) and clears it only
          // from the two submission callbacks the OTP popup supplies
          // (`features/to/modals/PaytoOTPVerificationModal/popup/index.jsx:152`
          // and `:156`). This refusal calls neither, and the overlay's backdrop
          // (z-index 1065) sits above the alert modal's (1055) — without this
          // release the customer is stranded behind an opaque screen on exactly
          // the flow the reported incident came from.
          dispatch({ type: SET_SHOW_PENDING, payload: false });

          resetThrottle();
          setShowTransactionDetails(false);

          // Read fresh rather than spreading the render-body binding: this can
          // run from a callback built several renders earlier. The reducer merges
          // `addTransactionInformation` at the top level but takes each step's
          // sub-object wholesale (`src/store/index.js:231-238`), so a stale
          // snapshot of the amount step would resurrect old amounts over newer
          // ones.
          const currentInformation =
            stateStore?.addTransactionInformation || {};
          const amountStepKey =
            ADD_TRANSACTION_STEP_REFERENCE[STEP_INDEX_AMOUNT];

          dispatch({
            type: SET_ADD_TRANSACTION_INFORMATION,
            payload: {
              ...currentInformation,
              [amountStepKey]: {
                ...currentInformation[amountStepKey],
                // Both pairs. With a second receiving currency added, a
                // surviving "another" amount keeps the step's send total
                // non-zero and leaves those inputs populated while the primary
                // pair is blank.
                [ADD_TRANSACTION_YOU_SEND_NAME]: '',
                [ADD_TRANSACTION_RECEIVER_GET_NAME]: '',
                [ADD_TRANSACTION_YOU_SEND_ANOTHER_NAME]: '',
                [ADD_TRANSACTION_RECEIVER_GET_ANOTHER_NAME]: '',
              },
            },
          });

          dispatch({
            type: SET_ADD_TRANSACTION_CURRENT_STEP,
            payload: STEP_INDEX_AMOUNT,
          });

          // The same generic payment-failure feedback the Pay button already
          // shows. No new translation key, and no message names the authority,
          // the price or any technical cause.
          //
          // Raised here rather than through the caller's `errorCallback` on
          // purpose: the PayTo agreement flow supplies its own distinct error
          // handler, and that handler is not the surface used to report this
          // refusal. `showTxnSubmitErrorModal` is also deliberately not used —
          // it waits, then discards the transfer and navigates away, which is
          // wrong for a condition recoverable in one edit.
          showPortalModalName({
            name: PORTAL_NAME_MODAL_DEFINE.ALERT_MODAL,
            title: t('popup_payment_fail'),
            modalOptions: {
              buttonLabel2: t('button_close'),
            },
            modalStyles: {
              subTextStyles: {
                textAlign: 'center',
              },
            },
            action: () => {},
          });
        };

        const handleOnPay = async ({
          transactionPayload = OBJECT_DEFAULT,
          successCallback = FUNC_DEFAULT,
          errorCallback = FUNC_DEFAULT,
        }) => {
          dispatch({ type: SET_SHOW_LOADING, payload: true });

          if (isUpdateTran) {
            console.log(`⭐ Payment 👉 handleOnPay ➡️ isUpdateTran ➡️ START ↩`);
            if (
              isDisabled &&
              !isChangePaymentMethod &&
              (paymentMethod === METHOD_PAYID ||
                paymentMethod === METHOD_DEPOSIT)
            ) {
              console.log(`⭐ Payment 👉 handleOnPay ➡️ isUpdateTran 1 ↩`);
              dispatch({
                type: SET_ADD_TRANSACTION_CURRENT_STEP,
                payload: 4,
              });

              setShowTransactionDetails(false);

              dispatch({ type: SET_SHOW_LOADING, payload: false });

              return;
            }

            const originalResponseSurcharge = transactionDetails?.surcharge;
            const shouldPersistSurchargeExclusion =
              Number(originalResponseSurcharge) > 0;

            if (
              isDisabled &&
              !isChangePaymentMethod &&
              paymentMethod === METHOD_EPAYMENT &&
              !shouldPersistSurchargeExclusion
            ) {
              console.log(`⭐ Payment 👉 handleOnPay ➡️ isUpdateTran 2 ↩`);
              try {
                const { data } = await api.getTran(token, refNumber);

                if (data) {
                  handlePayProcess(refNumber, data);
                }
              } catch (error) {
                checkMaintenance(error);
                checkSystemError(error);
                console.error(error?.message);
                dispatch({ type: SET_SHOW_LOADING, payload: false });
              }

              return;
            }

            console.log(`⭐ Payment 👉 handleOnPay ➡️ isUpdateTran 3 ↩`);
            try {
              /* TEST: Discount invalid by E002 - BEGIN */
              // const error = new Error('Invalid Discount');
              // error.response = {
              //   data: {
              //     status: 'BAD_REQUEST',
              //     timestamp: '09/07/2026 22:00:41',
              //     errorName: 'InvalidDiscountConditionError',
              //     errorCode: 'E002',
              //     message: 'Unexpected error',
              //     debugMessage: 'Invalid Discount',
              //     subErrors: null,
              //   },
              // };
              // throw error;
              /* TEST: Discount invalid by E002 - END */
              const { data } = await api.updateTran(token, refNumber, {
                ...transactionPayload,
                refNumber,
                status: transactionInformation?.status || STATUS_SUBMITTED,
              });

              if (data) {
                Cookies.set(SENDER_ID, senderId);
                handlePayProcess(refNumber, data);
                successCallback();
              }
            } catch (error) {
              checkMaintenance(error);
              checkSystemError(error);
              dispatch({ type: SET_SHOW_LOADING, payload: false });
              console.error(error?.message);
              const { errorCode } = error?.response?.data || {};
              // Only a coded discount validation error routes to the discount
              // failure handler; any other error (OTP, network, 5xx, generic)
              // falls through to the generic payment-fail callback. Mutually
              // exclusive so a single error never fires both handlers, matching
              // the isCreateNewTran path below.
              if (isDiscountApplied && isDiscountErrorCode(errorCode)) {
                handleDiscountValidationFailure(errorCode);
              } else {
                console.error(
                  `🔥 Payment ❌ handleOnPay ➡️ isUpdateTran ➡️ ERROR ↩`,
                  error?.message,
                );
                errorCallback?.(error?.response?.data);
              }
            } finally {
              resetThrottle();
            }

            return;
          }

          if (isCreateNewTran) {
            console.log(
              `⭐ Payment 👉 handleOnPay ➡️ isCreateNewTran ➡️ START ↩`,
              transactionPayload,
            );

            // DEV-1385: ask the quote-lifecycle module, reading current state at
            // submit time. This surface computes no eligibility of its own.
            if (!getIsQuoteAuthorityUsable()) {
              refuseCreateWithoutQuoteAuthority();
              return;
            }

            // The decision above and the authority submitted below must come
            // from the same current state. The render body destructures
            // `quoteToken` and the payload is built from that binding, so a
            // submission re-entered from a callback built several renders
            // earlier could otherwise pass the decision while carrying the
            // spent authority — the PayTo one-time-code variant of the reported
            // incident.
            const createPayload = {
              ...transactionPayload,
              quoteToken: getCurrentQuoteAuthority(),
            };

            try {
              /* TEST: Discount invalid by E002 - BEGIN */
              // const error = new Error('Invalid Discount');
              // error.response = {
              //   data: {
              //     status: 'BAD_REQUEST',
              //     timestamp: '09/07/2026 22:00:41',
              //     errorName: 'InvalidDiscountConditionError',
              //     errorCode: 'E002',
              //     message: 'Unexpected error',
              //     debugMessage: 'Invalid Discount',
              //     subErrors: null,
              //   },
              // };
              // throw error;
              /* TEST: Discount invalid by E002 - END */

              const { data } = await api.createTran(token, createPayload);

              if (data) {
                const { refNumber } = data;
                Cookies.set(SENDER_ID, senderId);

                // DEV-1385: the quote is spent the moment this create succeeds.
                // Dispatched here, before the shared post-create process, so no
                // present or future early return inside that process can skip
                // it. It is applied only on this path: not on the update path,
                // and not inside the shared process itself, which is also
                // entered by a read that consumes no authority — clearing there
                // would discard a live quote. The authority and the dedup
                // signature are emptied together, and the fee, original fee and
                // remittance on the same state survive by reference.
                setCalculatorRoundingResponse(
                  buildInvalidatedQuoteAuthorityResponse(),
                );

                handlePayProcess(refNumber, data);
                successCallback();
              }

              let createNewTranPromise = [];

              // handle save profile occupation
              const payloadOccupation = {
                job: transactionPayload.job,
                previousJob: transactionPayload.prevJob,
              };
              const { data: dataOccupation } = await api.getOccupation(token);
              if (dataOccupation) {
                const profileJob = dataOccupation?.job;
                const profilePrevJob = dataOccupation?.previousJob;

                const isChangeOccupation =
                  profileJob !== payloadOccupation?.job;
                const isChangePrevOccupation =
                  profilePrevJob &&
                  payloadOccupation?.previousJob &&
                  profilePrevJob !== payloadOccupation?.previousJob;

                if (
                  transactionPayload.job &&
                  (isChangeOccupation || isChangePrevOccupation)
                ) {
                  createNewTranPromise.push(
                    api.saveOccupation(token, payloadOccupation),
                  );
                }
              }

              // handle save receiver relationship
              const receiverRelationship = currentReceiver?.relationship;
              const isChangeRelationship =
                receiverRelationship !== transactionPayload?.relationship;
              if (isChangeRelationship) {
                createNewTranPromise.push(
                  api.updateRelationship(
                    token,
                    transactionPayload.receiverId,
                    transactionPayload?.relationship,
                  ),
                );
              }

              if (!isEmpty(createNewTranPromise)) {
                Promise.all(createNewTranPromise);
              }

              // const { refNumber: refNumberNew } = data;
              // if (!isEmpty(refNumberNew)) {
              //   refNumber = refNumberNew;
              // }
              // Cookies.set(SENDER_ID, senderId);
              // handlePayProcess(refNumberNew, data);
            } catch (error) {
              console.error(
                `🔥 PaymentMethod ❌ handleOnPay ➡️ error 1 ↩`,
                error?.message,
              );
              if (error?.code === 'ERR_CANCELED') {
                showTxnSubmitErrorModal();
                return;
              }
              checkMaintenance(error);
              checkSystemError(error);
              dispatch({ type: SET_SHOW_LOADING, payload: false });
              const { errorCode } = error?.response?.data || {};
              if (isDiscountApplied && isDiscountErrorCode(errorCode)) {
                handleDiscountValidationFailure(errorCode);
              } else {
                console.error(
                  `🔥 Payment ❌ handleOnPay ➡️ isCreateNewTran ➡️ ERROR ↩`,
                  error?.message,
                );
                errorCallback?.(error?.response?.data);
              }
            } finally {
              resetThrottle();
            }

            return;
          }

          try {
            const { data } = await api.getTran(token, refNumber);

            if (data) {
              handlePayProcess(refNumber, data);
            }
          } catch (error) {
            checkMaintenance(error);
            checkSystemError(error);
            console.error(
              `🔥 PaymentMethod ❌ handleOnPay ➡️ error 2 ↩`,
              error?.message,
            );
            dispatch({ type: SET_SHOW_LOADING, payload: false });
          } finally {
            resetThrottle();
          }
        };

        const handleOnPayByDeposit = async (urlRedirect) => {
          const homeUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
          const failPath = `${homeUrl}/tran?refNumber=${refNumber}&paymentStatus=${STATUS_FAIL}`;

          if (urlRedirect) {
            window.location.href = urlRedirect;

            return;
          }

          window.location.href = failPath;

          handleOnCloseFormPaymentByDeposit();
        };

        const handleOnPayByPaymentMethod = async (transactionPayloadExt) => {
          throttle(async () => {
            // The Pay button forwards its click event as the argument, so ignore
            // it unless a real payload object is passed. Spreading a DOM/synthetic
            // event leaks an HTMLButtonElement into the payload and breaks JSON
            // serialization with a "circular structure" error on createTran.
            const isDomEvent =
              transactionPayloadExt != null &&
              (transactionPayloadExt.nativeEvent !== undefined ||
                transactionPayloadExt.target !== undefined);
            let transactionPayloadSubmit = {
              ...transactionPayload,
              ...(isDomEvent ? {} : transactionPayloadExt),
            };
            if (paymentMethod === METHOD_PAYTO) {
              dispatch({ type: SET_SHOW_LOADING, payload: true });
              const isReceiverVerified = await onCheckReceiverVerifiedByOTP(
                transactionPayload?.receiverId,
                (otpData) => {
                  const { isVerified, token } = otpData || {};
                  transactionPayloadSubmit = {
                    ...transactionPayloadSubmit,
                    otpToken: token,
                  };
                  if (!isVerified) {
                    showPaytoOTPVerificationModal(
                      transactionPayloadSubmit,
                      (transactionPayload, successCallback, errorCallback) => {
                        console.log(
                          `⭐ PaymentMethod STEP 👉 handleOnPayByPaymentMethod ➡️ METHOD_PAYTO ➡️ transactionPayload ↩`,
                          transactionPayload,
                        );
                        handleOnPay({
                          transactionPayload: transactionPayload,
                          successCallback: () => {
                            successCallback();
                          },
                          errorCallback: (errorData) => {
                            errorCallback?.(errorData);
                          },
                        });
                      },
                      () => {
                        resetThrottle();
                      },
                    );
                  }
                },
                (errorData) => {
                  dispatch({ type: SET_SHOW_LOADING, payload: false });
                  onOpenPaytoErrorCodeModal(
                    errorData,
                    '',
                    '',
                    () => {
                      setShowTransactionDetails(false);
                    },
                    '',
                    {},
                    payloadTransformFromPaytoAccountInformation(
                      paytoAccountInformation,
                    ),
                  );
                },
              );
              if (!isReceiverVerified) return;
              transactionPayloadSubmit = {
                ...transactionPayloadSubmit,
                agreementUID: paytoAccountInformation?.id,
              };
            }

            console.log(
              `⭐ PaymentMethod STEP 👉 handleOnPayByPaymentMethod ➡️ PRE ➡️ transactionPayloadSubmit ↩`,
              transactionPayloadSubmit,
            );
            handleOnPay({
              transactionPayload: transactionPayloadSubmit,
              successCallback: () => {},
              errorCallback: (errorData) => {
                dispatch({ type: SET_SHOW_LOADING, payload: false });
                showPortalModalName({
                  name: PORTAL_NAME_MODAL_DEFINE.ALERT_MODAL,
                  title: t('popup_payment_fail'),
                  modalData: {
                    errorData,
                  },
                  modalOptions: {
                    buttonLabel2: t('button_close'),
                  },
                  modalStyles: {
                    subTextStyles: {
                      textAlign: 'center',
                    },
                  },
                  action: () => {},
                });
              },
            });
          });
        };

        const renderCalculatorFormMobile = () => {
          if (isDesktop) return null;
          if (isEmpty(countryConfig)) return null;
          return (
            <CalculatorForm
              countryConfig={countryConfig}
              isCalculatorFormAccordion={true}
            />
          );
        };
        const renderCalculatorFormDesktop = () => {
          if (!isDesktop) return null;
          if (isEmpty(countryConfig)) return null;
          return <CalculatorForm countryConfig={countryConfig} />;
        };

        const renderActionsButton = () => (
          <NextWrap style={{ width: isDesktop && '666px' }}>
            {renderCalculatorFormMobile()}
            <ActionWrapper>
              <ButtonCommonWrap>
                <ButtonCommon
                  value={t('button_back')}
                  onClick={handleBackStep}
                  styles={{
                    margin: '0px',
                    width: !isDesktop && '100%',
                  }}
                  color="var(--ds-c-blue)"
                  background="var(--ds-c-white)"
                  borderNameVariable={isDesktop && '--border-filter'}
                  isFill={false}
                />
              </ButtonCommonWrap>
              <ButtonCommon
                value={t('button_review_and_pay')}
                color="var(--c-primary)"
                background="var(--bg-primary)"
                isFill={true}
                styles={{
                  margin: '0px',
                  width: isDesktop ? '206px' : '50%',
                }}
                onClick={handleNextStep}
                isDisabled={isNextDisabled}
                isUseKeyDown={!isNextDisabled}
              />
            </ActionWrapper>
          </NextWrap>
        );

        const handleDiscardDiscountInvalidPopup = () => {
          setShowDiscountInvalidPopup(false);
          if (isShowTransactionDetails) {
            handleRemoveDiscountApplied();
          }
        };
        const renderDiscountInvalidPopup = (isOpen) => {
          /* Figma: https://www.figma.com/proto/xpUlBfRSnMMgPtyDAUAKzv/Profile?type=design&node-id=4135-81769&t=PwqxGUgCtP9mwarN-0&scaling=scale-down&page-id=1%3A16&starting-point-node-id=4135%3A81443&show-proto-sidebar=1 */
          // if (isShowTransactionDetails) {
          //   return (
          //     <InformPopup
          //       isOpen={isOpen}
          //       imageSrc={NoticeIcon}
          //       imagesStyles={{
          //         width: '124px',
          //         height: '100px',
          //         marginBottom: '8px',
          //       }}
          //       text={`${t('discount_check_invalid_title_1')}<br/>${t(
          //         'discount_check_invalid_title_2'
          //       )}`}
          //       content={[
          //         t('discount_check_invalid_desc_1'),
          //         t('discount_check_invalid_desc_2'),
          //       ]}
          //       buttonLabel1={t('button_discard')}
          //       onClose={handleDiscardDiscountInvalidPopup}
          //       buttonLabel2={t('button_ok')}
          //       onClick={handleCloseDiscountInvalidPopup}
          //       isBackdropOverlap={true}
          //       zIndexBackdropOverlap={1055}
          //     />
          //   );
          // }

          return (
            <InformPopup
              isOpen={isOpen}
              imageSrc={NoticeIcon}
              styles={{
                width: isDesktop ? '436px' : '100%',
              }}
              imagesStyles={{
                width: '75px',
                height: '60px',
                marginBottom: '8px',
              }}
              text={t('label_important')}
              content={t(
                errorCode
                  ? `popup_discount_invalid_error_msg_${errorCode.toLowerCase()}`
                  : `popup_discount_invalid_error_msg`,
              )}
              alignContent="center"
              buttonLabel1={t('button_close')}
              onClose={handleCloseDiscountInvalidPopup}
              buttonLabel2={
                hasOtherEligibleDiscounts ? t('button_other_offers') : null
              }
              onClick={handleViewOtherOffers}
              isBackdropOverlap={true}
              zIndexBackdropOverlap={1055}
            />
          );
        };

        const handleBackStep = () => {
          dispatch({
            type: SET_ADD_TRANSACTION_CURRENT_STEP,
            payload: currentStep - 1,
          });
          if (paymentMethod === METHOD_PAYTO) {
            resetPaytoAccountsAgreement(false);
          }
        };

        const checkPaymentMethodItemDisabled = (paymentMethod) => {
          if (paymentMethod === METHOD_PAYTO)
            return (
              (isArray(paytoAccountsAgreement) &&
                paytoAccountsAgreement?.some(
                  (accountAgreement) => accountAgreement?.blocked,
                )) ||
              (payLimitConfig && isPaymentMethodDisabled(paymentMethod)) ||
              checkServiceAlertsOfPaymentMethodItemDisable({
                serviceAlertsStore,
                paymentMethod,
              })
            );
          return (
            (payLimitConfig && isPaymentMethodDisabled(paymentMethod)) ||
            checkServiceAlertsOfPaymentMethodItemDisable({
              serviceAlertsStore,
              paymentMethod,
            })
          );
        };
        const renderPaytoAccountAgreement = () => {
          if (isEmpty(countryConfig)) return null;
          if (checkPaymentMethodItemDisabled(paymentMethod)) return null;
          if (isPaytoBlocked) return null;
          return <PaytoAccountsAgreement validation={validation} />;
        };

        const renderPaymentMethodsGrid = () => {
          if (IS_PAYTO_CONFIG_DISABLE || !isPayToVisibleConfig)
            return (
              <PaymentMethodsGrid
                countryConfig={countryConfig}
                information={information}
                setInformation={setInformation}
                validation={validation}
                setValidation={setValidation}
                isSelectRequired={
                  validation[ADD_TRANSACTION_PAYMENT_METHOD_NAME]
                }
                checkPaymentMethodItemDisabled={checkPaymentMethodItemDisabled}
              />
            );
          return (
            <PaymentMethodsGridExt
              countryConfig={countryConfig}
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
              isSelectRequired={validation[ADD_TRANSACTION_PAYMENT_METHOD_NAME]}
              checkPaymentMethodItemDisabled={checkPaymentMethodItemDisabled}
              isPreventPaymentMethodAutoSelect={
                isPreventPaymentMethodAutoSelect
              }
            />
          );
        };

        useAutoShowEventModal({
          screenId: SCREEN_ID_REMITTANCE_STEP_4,
          params: [],
          modalStyles: {},
          modalOptions: {},
          conditions: [isPaymentSuccessfully],
        });

        if (isPaymentSuccessfully) {
          return (
            <TransactionSummaryWithEvent
              refNumber={refNumber}
              totalPayAmount={totalPayAmount}
              cardInformation={cardInformation}
              screenId={SCREEN_ID_REMITTANCE_SUCCESS}
              onlineRef={refNumber}
              isCheckEventEligible={isPaymentSuccessfully}
              isForceToCheckEventEligible={isPaymentSuccessfully}
              mobileViewInitial={MOBILE_VIEW_MODAL}
              isFullScreenWithHeader={true}
              isSkip={!isPaymentSuccessfully}
              action1Name="close"
            />
          );
        }

        return (
          <>
            {isShowTransactionDetails && (
              <>
                {isMobile || isTablet ? (
                  <FormTransactionDetailsMobile
                    countryConfig={countryConfig}
                    isOpen={isShowTransactionDetails}
                    onClose={handleOnCloseTransactionDetailsPopup}
                    onClick={handleOnPayByPaymentMethod}
                    isOnClickLocked={isThrottleLocked}
                  />
                ) : (
                  <FormTransactionDetails
                    countryConfig={countryConfig}
                    isOpen={isShowTransactionDetails}
                    onClose={handleOnCloseTransactionDetailsPopup}
                    onClick={handleOnPayByPaymentMethod}
                    isOnClickLocked={isThrottleLocked}
                  />
                )}
              </>
            )}

            {isShowFormPaymentByDeposit && (
              <>
                {isMobile || isTablet ? (
                  <FormPaymentByDepositMobile
                    isOpen={isShowFormPaymentByDeposit}
                    transactionInformation={transactionInformation}
                    cardInformation={cardInformation}
                    setCardInformation={setCardInformation}
                    cardValidation={cardValidation}
                    setCardValidation={setCardValidation}
                    onClose={handleOnCloseFormPaymentByDeposit}
                    onClick={handleOnPayByDeposit}
                  />
                ) : (
                  <FormPaymentByDeposit
                    isOpen={isShowFormPaymentByDeposit}
                    transactionInformation={transactionInformation}
                    cardInformation={cardInformation}
                    setCardInformation={setCardInformation}
                    cardValidation={cardValidation}
                    setCardValidation={setCardValidation}
                    onClose={handleOnCloseFormPaymentByDeposit}
                    onClick={handleOnPayByDeposit}
                  />
                )}
              </>
            )}

            {isShowDiscountInvalidPopup &&
              renderDiscountInvalidPopup({
                isOpen: isShowDiscountInvalidPopup,
              })}

            <BodySectionHeader
              titleBodySection={
                isMakePayment
                  ? t('add_transaction_title_make_payment')
                  : t('add_transaction_title_new_transaction')
              }
              titleSection={t('add_transaction_title_receiver_payment')}
              CalculatorComponent={renderCalculatorFormDesktop()}
              onToggleCancelPopup={handleOnToggleCancelPopup}
            />
            <PaymentMethodStyled $currentStep={currentStep}>
              {renderPaymentMethodsGrid()}
              {renderPaytoAccountAgreement()}
              <ParagraphCheckbox
                ref={tickRef}
                $isError={validation?.[ADD_TRANSACTION_TICK_CHECKBOX]}
                onClick={handleOnChangeTickChecked}
              >
                <FormCheckStyled
                  name={ADD_TRANSACTION_TICK_CHECKBOX_FIELD.name}
                  type={ADD_TRANSACTION_TICK_CHECKBOX_FIELD.type}
                  label={ADD_TRANSACTION_TICK_CHECKBOX_FIELD.label}
                  checked={isTickChecked}
                  readOnly={ADD_TRANSACTION_TICK_CHECKBOX_FIELD.isReadOnly}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: stringUtils.replaceKeyword(
                      t('form_checkbox_acknowledge_required'),
                      [
                        {
                          key: 'lang',
                          value: locate,
                        },
                        {
                          key: 'host',
                          value: HOME_URL[theme],
                        },
                      ],
                    ),
                  }}
                />
              </ParagraphCheckbox>
              {renderActionsButton()}
            </PaymentMethodStyled>
          </>
        );
      },
    ),
  ),
);

const PaymentMethodStyled = styled.div`
  display: inline-block;
  width: 100%;
  margin-top: -8px;
  padding-inline: 0px;
  padding-bottom: 200px;
  background: var(--ds-c-white);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 100%;
    margin-top: 0px;
    padding-inline: 0px;
    padding-bottom: unset;
  }
`;

const ParagraphCheckbox = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;

  color: ${(props) =>
    props.$isError ? 'var(--ds-c-red)' : 'var(--ds-c-grey-dark)'};
  padding: 0;
  margin: 0;
  margin-left: 0px;
  margin-top: 24px !important;
  cursor: pointer !important;
  user-select: none;
  width: 100%;

  a {
    color: ${(props) =>
      props.$isError ? 'var(--ds-c-red)' : 'var(--ds-c-blue)'};
    text-decoration: none;

    &:hover {
      color: ${(props) =>
        props.$isError ? 'var(--ds-c-red-hover)' : 'var(--ds-c-blue-hover)'};
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-top: 0px;
    width: 666px;

    font-size: 14px;
    line-height: 17px;
  }
`;

const FormCheckStyled = styled(Form.Check)`
  ${Fade};
  width: fit-content;
  float: left;
  margin-bottom: 32px;
  margin-right: 10px;

  input:checked[type='checkbox'] {
    background-image: url(${CheckedIcon});
    background-size: cover;
  }

  input {
    border: none;
    border-radius: 2px;
    background-image: url(${CheckboxIcon});
    background-size: cover;
    width: 26px;
    height: 26px;
    cursor: pointer !important;
    margin-top: 0px;

    &:focus,
    &:active,
    &:checked {
      background-color: transparent;
      border: none;
      border-radius: 2px;
      box-shadow: none !important;
      filter: none !important;
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 32px;
  }
`;

export default PaymentMethod;
